<template>
  <div class="wallet">
    <div class="card">
      <img :src="qrcode" alt="">
      <div style="margin-top: 20px;font-size: 20px;">邀请码：{{ code }}</div>
    </div>
    <div class="block"></div>
    <Form class="filter" inline :label-width="80" :show-message="false" label-position="left">
      <searchFormItemInput label="昵称" placeholder="请输入昵称" v-model="searFrom.name"></searchFormItemInput>
      <div class="form-footer">
        <searchFormItemButton @on-click="getLog()"></searchFormItemButton>
        <searchFormItemClear @on-clear="clear()"></searchFormItemClear>
      </div>
    </Form>
    <div class="table" v-loading="loading">
      <Table :columns="columns" :data="tableData"></Table>
      <PageComponents
        :total="tableShow.listCount"
        :current="tableShow.currentPage"
        :pageSize="tableShow.pageSize"
        @on-change="changePage"
      ></PageComponents>
    </div>
    <Modal title="图片预览" v-model="ImageModel.show">
      <img :src="ImageModel.src" v-if="ImageModel.src" width="100%">
    </Modal>
  </div>
</template>

<script>
import headerComponents from '../../components/header'
import PageComponents from '../../components/page'
import tabNav from '../../components/tabNav'
import {
  searchFormItemSelect,
  searchFormItemDate,
  searchFormItemInput,
  searchFormItemButton,
  searchFormItemClear
} from '../../components/search-form-item'

export default {
  name: 'wallet',
  components: {
    PageComponents,
    searchFormItemButton,
    searchFormItemClear,
    searchFormItemSelect,
    searchFormItemDate,
    searchFormItemInput,
    headerComponents,
    tabNav
  },
  data () {
    return {
      loading: true,
      tableShow: {
        currentPage: 1,
        pageSize: 10,
        listCount: 0
      },
      searFrom: {
        name: ''
      },
      qrcode: '',
      code: '',
      columns: [
        {
          title: '头像',
          key: 'head_img',
          render: (h, params) => {
            let vm = this
            return h('img', {
              attrs: {
                src: params.row.head_img,
                width: 60,
                style: 'border-radius: 2px;margin-top:4px;'
              },
              on: {
                click () {
                  vm.showImg(params.row.head_img)
                }
              }
            })
          }
        },
        {
          title: '昵称',
          key: 'nickname'
        }
      ],
      tableData: [],
      ImageModel: {
        show: false,
        loading: false,
        src: ''
      }
    }
  },
  created () {
    let vm = this

    this.$request('63f71487bf122', {
    }).then(res => {
      vm.qrcode = res.data.data.mini_qrcode
      vm.code = res.data.data.code
    })
    vm.getLog()
  },
  methods: {
    changePage (page) {
      this.loading = true
      this.tableShow.currentPage = page
      this.getLog()
    },
    clear () {
      let vm = this
      vm.searFrom = {
        name: ''
      }
      this.loading = true
      this.getLog()
    },
    getLog () {
      let vm = this
      this.$request('6152c1751ce39', {
        page: vm.tableShow.currentPage,
        limit: vm.tableShow.pageSize,
        name: vm.searFrom.name
      }).then(res => {
        vm.tableData = res.data.data.list
        vm.tableShow.listCount = res.data.data.count
        this.loading = false
      })
    },
    showImg (src) {
      this.ImageModel.src = src
      this.ImageModel.show = true
    }
  }
}
</script>

<style scoped lang="less">
.wallet {
  .card {
    padding: 20px 10px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    img{
      width: 150px;
      height: 150px;
    }
    .total {
      display: flex;
      align-items: center;

      .total-item {
        min-width: 120px;
        margin-left: 10px;

        .title {
          font-size: 12px;
          color: rgb(102, 102, 102);
          letter-spacing: 0;
          line-height: 1;
        }

        .num {
          font-size: 28px;
          color: rgb(17, 17, 17);
          letter-spacing: 0;
          line-height: 1;
          margin-top: 10px;
        }
      }
    }

  }

  .block {
    width: 100%;
    height: 15px;
    background-color: #f7f8fa;
  }

  .filter {
    padding: 10px;
  }

  .table {
    padding: 10px;
  }
}

</style>
